<template>
  <router-link
    exact-active-class="is-active"
    class="navbar-item"
    :to="item.path"
  >
    {{ item.name }}
  </router-link>
</template>

<script>
export default {
  name: 'MenuBarItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
